import { getBytes, ref } from 'firebase/storage';

import { storage } from './firebase';

/**
 * @param {'beer' | 'hospitality'} reviewType
 * @param {string} reviewId
 * @param {string} photoId
 * @param {'thumb' | 'display'} variantName
 * @returns {string}
 */
export function buildReviewPhotoVariantPath(
  reviewType,
  reviewId,
  photoId,
  variantName,
) {
  return `review-photos/${reviewType}/${reviewId}/${photoId}/variants/${variantName}.jpg`;
}

/**
 * Loads a private review-photo variant via authenticated getBytes.
 * Caller must revoke the returned object URL when done.
 * @param {'beer' | 'hospitality'} reviewType
 * @param {string} reviewId
 * @param {string} photoId
 * @param {'thumb' | 'display'} variantName
 * @returns {Promise<string>} object URL for the image bytes
 */
export async function loadReviewPhotoVariantObjectUrl(
  reviewType,
  reviewId,
  photoId,
  variantName,
) {
  const objectPath = buildReviewPhotoVariantPath(
    reviewType,
    reviewId,
    photoId,
    variantName,
  );
  const storageRef = ref(storage, objectPath);
  const bytes = await getBytes(storageRef);
  const blob = new Blob([bytes], { type: 'image/jpeg' });
  return URL.createObjectURL(blob);
}
